import React, { PureComponent } from 'react';

import IconHero from '../../components/IconHero';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';

import transform from '../transform';
import defaultSettings from './settings';

export default class SalesPage extends PureComponent {
    render() {
        const { redirectToContactSales } = this.props;
        const { breadcrumbs, iconHero } = transform({ defaultSettings });

        return (
            <div>
                <HeaderBreadcrumbs {...breadcrumbs} />
                <IconHero {...iconHero} onCTAClick={redirectToContactSales} />
            </div>
        );
    }
}
